var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doc-page d-flex mx-auto flex-row"},[_c('loading-dialog',{attrs:{"show":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }